export default __webpack_public_path__ + "static/media/Purchase-Orders.405cf55e.svg";